import { render, staticRenderFns } from "./ChatWrapper.vue?vue&type=template&id=6450f489&scoped=true&"
import script from "./ChatWrapper.vue?vue&type=script&lang=js&"
export * from "./ChatWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ChatWrapper.vue?vue&type=style&index=0&id=6450f489&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6450f489",
  null
  
)

export default component.exports